/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Vue from 'vue'
import Config from '@/config'

export default {
  showModalQuickBuy (state, visible) {
    state.modalQuickBuy = visible
  },
  setProducts (state, products) {
    state.list = products
  },
  setAvailableFilters (state, { filters }) {
    const available = {}
    let chosenEmpty = Object.keys(state.filters.chosen).length === 0
    let chosenValues = {}
    for (let i in filters) {
      const attrCode = filters[i].attribute_code
      available[attrCode] = {
        label: filters[i].label,
        options: filters[i].options
      }
      if (chosenEmpty) {
        chosenValues[attrCode] = []
      }
    }
    if (chosenEmpty) {
      Vue.set(state.filters, 'chosen', chosenValues)
    }
    Vue.set(state.filters, 'available', available)
  },
  setPagination (state, pagination) {
    state.pagination = { ...state.pagination, ...pagination }
  },
  setColumns (state, columns) {
    state.columns = columns
  },
  setSort (state, sort) {
    state.sort = sort
  },
  setSortOrientation (state, sortOrientation) {
    const consentite = ['DESC', 'ASC']
    const newOrientation = sortOrientation.toUpperCase()
    if (consentite.includes(newOrientation)) {
      state.sortOrientation = newOrientation
    } else {
      state.sortOrientation = Config.Theme.sortOrientation
    }
  },
  setSortable (state, sortable) {
    state.sortable = sortable
  },
  clearFilters (state) {
    state.filters.chosen = []
  },
  updateFilters (state, { attrCode, valueSelected }) {
    state.filters.chosen[attrCode] = valueSelected
  },
  setFiltersChosen (state, filters) {
    Vue.set(state.filters, 'chosen', filters)
  },
  setListingView (state, filters) {
    if (Object.keys(filters).length > 0) {
      for (let i in filters) {
        state[i] = filters[i]
      }
    }
  },
  setQuickView (state, value) {
    state.quickView = value
  }
}
